import styled from 'styled-components';
import { mediaq } from '~/themes/style-utils-v2';
import { newColors } from '~/themes/variables';
export const Outer = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 12px;

  .react-international-phone-input-container {
    width: 100%;
    align-items: center;
    gap: 4px;
  }

  .react-international-phone-country-selector-button {
    height: 51px;
    border-color: transparent;
    border-right-color: transparent;
    background-color: transparent;
    ${mediaq.sm `
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
      height: ${(props) => (props.type === 'checkbox' ? '16px' : '40px')};
    `}
  }

  .react-international-phone-country-selector-dropdown {
    border-radius: 6px;
    outline: none;
  }

  .react-international-phone-input-container .react-international-phone-input, .pattern-format-input {
    background-color: white;
    color: ${newColors.black};
    height: 51px;
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;
    border: 1px ${newColors.purple800} solid;
    border-left: 0;
    width: 100%;
    ${mediaq.sm `
      border-top-right-radius: 6px;
      border-bottom-right-radius: 6px;
      height: ${(props) => (props.type === 'checkbox' ? '16px' : '40px')};
    `}
  }
  .pattern-format-input.error {
    border-color: ${newColors.error};
  }
`;
export const Inner = styled.div `
  display: flex;
  flex-direction: ${(props) => (props.type === 'checkbox' ? 'row-reverse' : 'column')};
  justify-content: ${(props) => (props.type === 'checkbox' ? 'start' : 'normal')};
  align-items: ${(props) => (props.type === 'checkbox' ? 'center' : 'normal')};
  gap: 8px;
  ${mediaq.sm `
    justify-content: ${(props) => (props.type === 'checkbox' ? 'center' : 'normal')};
  `}
  &[type='checkbox'] {
    accent-color: ${newColors.purple500};
  }
`;
// padding-right: ${(props) => (props.type === 'checkbox' ? '0px' : '84px')};
//   padding-left: ${(props) => (props.type === 'checkbox' ? '88px' : '84px')};
//   ${mediaq.md`
//   padding-right: ${(props: InnerProps) => (props.type === 'checkbox' ? '0px' : '48px')};
//   padding-left: ${(props: InnerProps) => (props.type === 'checkbox' ? '52px' : '48px')};
//   `}
//   ${mediaq.sm`
//   padding-right: ${(props: InnerProps) => (props.type === 'checkbox' ? '0px' : '12px')};
//   padding-left: ${(props: InnerProps) => (props.type === 'checkbox' ? '0px' : '12px')};
//   justify-content: ${(props: InnerProps) => (props.type === 'checkbox' ? 'center' : 'normal')};
//   `}
export const Label = styled.label `
  font-size: 12px;
  font-weight: 600;
  text-align: left;
  padding-left: 4px;
`;
export const InputField = styled.input `
  width: ${(props) => (props.type === 'checkbox' ? '16px' : '100%')};
  display: flex;
  align-items: center;
  justify-content: center;
  height: ${(props) => (props.type === 'checkbox' ? '16px' : '51px')};
  text-align: left;
  background: ${newColors.snow};
  border-radius: 12px;
  border: ${(props) => props.isError ? `1px ${newColors.error} solid` : `1px ${newColors.purple800} solid`};
  color: ${newColors.fontDefaultColor};
  padding: 5px;
  ${mediaq.sm `
    border-radius: 6px;
    height: ${(props) => (props.type === 'checkbox' ? '16px' : '40px')};
  `}
`;
export const Message = styled.div `
  width: 100%;
  font-size: 12px;
  color: ${newColors.error};
  text-align: left;
`;
// padding-left: 88px;
//   ${mediaq.md`
//   padding-left: 52px;
// `}
//   ${mediaq.sm`
//   padding-left: 16px;
// `}
export const Asterisk = styled.span `
  color: ${newColors.error};
  margin-left: 2px;
`;
export const PhoneInputRow = styled.div `
  display: flex;
  flex-direction: row;
`;
export const CountryPrefix = styled.div `
  background-color: white;
  color: ${newColors.black};
  padding: 2px 3px 0;
  margin-left: 6px;
  height: 51px;
  border: 1px ${newColors.purple800} solid;
  border-right: 0;
  border-radius: 12px 0 0 12px;
  display: flex;
  align-items: center;
  ${mediaq.sm `
    height: 40px;
    border-radius: 6px 0 0 6px;
  `}
`;
